var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dialog-container wt-dialog-container"},[_c('wt-form-table',{attrs:{"form":_vm.form},on:{"update:form":function($event){_vm.form=$event},"on-button-action":_vm.onButtonAction}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }